import ThemeToggle from "components/ThemeToggle/ThemeToggle";

const Footer = () => {
  return (
    <div className="hidden lg:flex items-center justify-center gap-1.5 py-2 text-[11px] text-muted-foreground/60">
      <span>© {new Date().getFullYear()} Tapit Ltd</span>
      <span>·</span>
      <a
        href="https://centralvaluations.ie/support"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-muted-foreground transition-colors"
      >
        Support
      </a>
      <span>·</span>
      <a
        href="https://centralvaluations.ie/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-muted-foreground transition-colors"
      >
        Terms
      </a>
      <span>·</span>
      <a
        href="https://centralvaluations.ie/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-muted-foreground transition-colors"
      >
        Privacy
      </a>
      <span className="ml-2">
        <ThemeToggle />
      </span>
    </div>
  );
};

export default Footer;
